import React from 'react'

import mutation from './mutation.graphql'

import DeleteEntityModal from 'components/shared/DeleteEntityModal'

export default function DeletePickupPersonModal(props) {
  const { pickupPerson } = props

  return (
    <DeleteEntityModal
      entity={pickupPerson}
      modalId={`confirmDeletePickupPerson${pickupPerson.id}`}
      fieldGroup='pickupPeople'
      modalTitle='Delete Pick-up Person?'
      successMessage='Pick-up Person Deleted'
      mutation={mutation}
      mutationName='deletePickupPerson'
      {...props}
    />
  )
}
